import { PageWrap } from '../../components';
import { useMyUserClient } from '../../hooks';
import Prose, { Li, P, ProseLink, Ul } from './Prose';

export default function IndexPage() {
  const myUser = useMyUserClient();
  if (!myUser.agencyRole) return null;

  return (
    <PageWrap limitWidth="smaller">
      <Prose>
        <P>The Basics</P>

        <Ul>
          <Li>
            <ProseLink to="/operations/3rd-party-services">
              Third-party services
            </ProseLink>
          </Li>
          <Li>
            <ProseLink to="/operations/security">Security</ProseLink>
          </Li>
          <Li>
            <ProseLink to="/operations/maintenance-tickets">
              Maintenance tickets
            </ProseLink>
          </Li>
        </Ul>

        <P>QA &amp; Release Management</P>

        <Ul>
          <Li>Testing releases</Li>
          <Li>
            <ProseLink to="/operations/qa-releasing-to-users">
              Releasing to users
            </ProseLink>
          </Li>
        </Ul>

        <P>Design</P>

        <Ul>
          <Li>
            <ProseLink to="/operations/design-file-organisation">
              File organisation
            </ProseLink>
          </Li>
          <Li>Feedback processes</Li>
        </Ul>

        <P>Development</P>

        <Ul>
          <Li>
            <ProseLink to="/operations/development-workflow">
              Development workflow
            </ProseLink>
          </Li>
        </Ul>

        <P>Front-end development</P>

        <P>Back-end development</P>
      </Prose>
    </PageWrap>
  );
}
